import { render, staticRenderFns } from "./ModalCriaProcessoPorRegistro.vue?vue&type=template&id=0453ccf3&scoped=true"
import script from "./ModalCriaProcessoPorRegistro.vue?vue&type=script&lang=js"
export * from "./ModalCriaProcessoPorRegistro.vue?vue&type=script&lang=js"
import style0 from "./ModalCriaProcessoPorRegistro.vue?vue&type=style&index=0&id=0453ccf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453ccf3",
  null
  
)

export default component.exports